import { ChangeDetectionStrategy, Component, output } from "@angular/core";

import { ICON_PATHS } from "../../constants/icon-paths.constant";
import { MenuStore } from "../../stores/menu.store";
import { UserStore } from "../../stores/user.store";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-header",
  templateUrl: "header.component.html",
  styleUrls: ["header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent {
  logoutIcon = this.sanitizer.bypassSecurityTrustResourceUrl(ICON_PATHS.logout);
  personOutline = this.sanitizer.bypassSecurityTrustResourceUrl(ICON_PATHS.person_outline);
  falabellaLogo = this.sanitizer.bypassSecurityTrustResourceUrl(ICON_PATHS.falabella_logo);

  toggleSidenav = output<void>();
  protected user = this.userStore.user;
  protected hasAdditionalItems = this.menuStore.hasAdditionalItems;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly userStore: UserStore,
    private readonly menuStore: MenuStore
  ) {}

  async logout(): Promise<void> {
    await this.userStore.logoutAndClearData();
  }

  onToggleSidenav(): void {
    this.toggleSidenav.emit();
  }
}
